import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'

import {App} from './App'

import {CopilotIndex} from './routes/CopilotIndex'
import {DiversityIndex} from './routes/DiversityIndex'
import {EnterpriseIndex} from './routes/EnterpriseIndex'
import {ShowPage} from './routes/ShowPage'

registerReactAppFactory('landing-pages', () => ({
  App,
  routes: [
    jsonRoute({path: '/about/diversity', Component: DiversityIndex}),
    jsonRoute({path: '/features/copilot', Component: CopilotIndex}),
    jsonRoute({path: '/features/preview/copilot-x', Component: CopilotIndex}),
    jsonRoute({path: '/enterprise', Component: EnterpriseIndex}),
    jsonRoute({path: '*', Component: ShowPage}),
  ],
}))
